import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  columnNames = [];
  tableData = [];
  atdashboard: boolean = false;
  atFacilityInfo: boolean = false;
  atFacilityListing: boolean = false;
  atCseListing: boolean = false;
  atAddCseForm: boolean = false;
  atCseMappedList: boolean = false;
  atAddMappingForm: boolean = false;
  atCseFacilityMapped: boolean = false;
  atAdminDashboard = false;

  constructor(private router: Router) {

    let routerArray = [
      { route: '/admin', routeComponent: 'atdashboard' },
      { route: '/admin/dashboard', routeComponent: 'atAdminDashboard' },
      { route: '/admin/facility-info', routeComponent: 'atFacilityInfo' },
      { route: '/admin/facility-listing', routeComponent: 'atFacilityListing' },
      { route: '/admin/cse-listing', routeComponent: 'atCseListing' },
      { route: '/admin/add-cse-form', routeComponent: 'atAddCseForm' },
      { route: '/admin/cse-mapped-list', routeComponent: 'atCseMappedList' },
      { route: '/admin/cse-facility-mapped', routeComponent: 'atCseFacilityMapped' },
      { route: '/admin/add-mapping-form', routeComponent: 'atAddMappingForm' },
    ]

    let allComponent = ['atFacilityListing', 'atFacilityInfo', 'atCseListing', 'atAddCseForm', 'atCseMappedList', 'atAddMappingForm', 'atCseFacilityMapped', 'atAdminDashboard', 'atdashboard',]

    for (let i = 0; i < routerArray.length; i++) {
      if ((router.url == routerArray[i].route) || (router.url.split('?')[0] == routerArray[i].route)) {    //Using split because in url we are also getting params
        for (let j = 0; j < allComponent.length; j++) {
          if (allComponent[j] == routerArray[i].routeComponent) {
            this[allComponent[j]] = true;
            // console.log('true', allComponent[j])
          } else {
            this[allComponent[j]] = false;
            // console.log('false', allComponent[j])
          }
        }
      }
    }
  }

  ngOnInit(): void {
  }

  showSideBar(event) {
    console.log('layout', event);
  }

}
